import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import Swal from 'sweetalert2';
import api from '../../services/api_adiantamento';
import apidesp from '../../services/api_despesas';
import { mask, unMask } from 'remask';
import moment from 'moment';
import { BsFileExcelFill, BsCurrencyDollar } from "react-icons/bs";
import styles from './styles.module.css';
import fileDownload from 'js-file-download';


export default function DespesasViagem() {

    let history = useHistory();

    const [nome, setNome] = useState('');
    const [matricula, setMatricula] = useState('');
    const [funcao, setFuncao] = useState('');
    const [setor, setSetor] = useState('');
    const [origem, setOrigem] = useState('');
    const [destino, setDestino] = useState('');
    const [objetivo, setObjetivo] = useState('');
    const [dtSaida, setDtSaida] = useState('');
    const [dtChegada, setDtChegada] = useState('');
    const [autorizacao, setAutorizacao] = useState('');
    const [banco, setBanco] = useState('');
    const [conta, setConta] = useState('');
    const [agencia, setAgencia] = useState('');
    const [cc, setCc] = useState('');
    const [gd, setGd] = useState('');
    const [qtdPedagio, setQtdPedagio] = useState('');
    const [vlrPedagio, setVlrPedagio] = useState('');
    const [qtdCombustivel, setQtdCombustivel] = useState('');
    const [vlrCombustivel, setVlrCombustivel] = useState('');
    const [qtdHospedagem, setQtdHospedagem] = useState('');
    const [vlrHospedagem, setVlrHospedagem] = useState('');
    const [qtdAlimentacao, setQtdAlimentacao] = useState('');
    const [vlrAlimentacao, setVlrAlimentacao] = useState('');
    const [qtdOutros, setQtdOutros] = useState('');
    const [vlrOutros, setVlrOutros] = useState('');
    const [vlrTaxi, setVlrTaxi] = useState('');
    const [qtdTaxi, setQtdTaxi] = useState('');
    const [vlrAdiantamento, setVlorAdiantamento] = useState('');
    const [dtPgto, setDtPgto] = useState('');
    const [id, setId] = useState('');
    const [canPay, setCanPay] = useState(false);
    const [valorTotal, setValorTotal] = useState('');
    const [valorDevolver, setValorDevolver] = useState('');
    const [valorReceber, setValorReceber] = useState('');
    const [downloading, setDownloading] = useState(false);
    const [salvando, setSalvando] = useState(false);
    const [pagando, setPagando] = useState(false);
    const [idDespPagar, setIdDespPagar] = useState('');
    const [dtPagar, setDtPagar] = useState('');
    const [modalPgtoOpen, setModalPgtoOpen] = useState(false);
    const [titularidade, setTitularidade] = useState('');
    const [cpf, setCpf] = useState('');

    const [despesas, setDespesas] = useState([]);

    const [modalNovaDespOpen, setModalNovaDespOpen] = useState(false);

    const [status, setStatus] = useState({
        items: [
            { id: 0, text: "NÃO PAGAS" },
            { id: 1, text: "PAGAS" },
            { id: 3, text: "TODAS" }
        ],
        selectItem: 0
    });


    useEffect(() => {

        var total = (vlrAdiantamento ? parseFloat(vlrAdiantamento.replaceAll('.', '').replace(',', '.')) : 0) - (valorTotal ? valorTotal : 0);
        if (total > 0) {
            setValorDevolver(total);
            setValorReceber(0);
        } else {
            setValorDevolver(0);
            setValorReceber(total * -1);
        }



    }, [valorTotal, vlrAdiantamento])

    useEffect(() => {

        var outros = parseFloat(vlrOutros.replaceAll('.', '').replace(',', '.')) * parseFloat(qtdOutros);

        var comb = parseFloat(vlrCombustivel.replaceAll('.', '').replace(',', '.')) * parseFloat(qtdCombustivel);

        var alim = parseFloat(vlrAlimentacao.replaceAll('.', '').replace(',', '.')) * parseFloat(qtdAlimentacao);

        var hosp = parseFloat(vlrHospedagem.replaceAll('.', '').replace(',', '.')) * parseFloat(qtdHospedagem);

        var pedagio = parseFloat(vlrPedagio.replaceAll('.', '').replace(',', '.')) * parseFloat(qtdPedagio);

        var taxi = parseFloat(vlrTaxi.replaceAll('.', '').replace(',', '.')) * parseFloat(qtdTaxi);
        var total = (outros ? outros : 0) + (comb ? comb : 0) + (alim ? alim : 0) + (hosp ? hosp : 0) + (taxi ? taxi : 0) + (pedagio ? pedagio : 0);

        setValorTotal(total);

    }, [vlrTaxi, qtdTaxi, vlrOutros, qtdOutros, vlrAlimentacao, qtdAlimentacao, vlrHospedagem, qtdHospedagem, vlrCombustivel, qtdCombustivel, qtdPedagio, vlrPedagio])


    useEffect(() => {
        apidesp.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    var itens = [];
                    response.data.usuario_perfil.forEach((perf, index) => {
                        if (parseInt(perf.perfil_id) === 7) {
                            setCanPay(true);
                        }

                    })
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        api.get(`/despviagem?canpay=${canPay}&status=${status.selectItem}`).then(function (response) {
            if (response.data) {
                setDespesas(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
        });
    }, [status, canPay]);


    function handleExcluirDesp(id) {
        Swal.fire({
            title: "TEM CERTEZA QUE DESEJA APAGAR A DESPESA?",
            showDenyButton: true,
            showConfirmButton: true,
            denyButtonText: "CANCELAR",
            confirmButtonText: "CONFIRMAR",
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                api.delete(`/despviagem/id/${id}`).then(function (response) {
                    if (response.data) {
                        var objdesp = Object.assign([], despesas);
                        var index = objdesp.findIndex(desp => desp.id === parseInt(id));
                        objdesp.splice(index, 1);
                        setDespesas(objdesp);
                        Swal.fire("APAGADO");
                        // setLogEmpresa(response.data);
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    // always executed
                });

            } else if (result.isDenied) {

            }
        })
    }

    function handleClickDesp(despesa) {

        setNome(despesa.nome);
        setMatricula(despesa.matricula);
        setFuncao(despesa.funcao);
        setSetor(despesa.setor);
        setOrigem(despesa.origem);
        setDestino(despesa.destino);
        setDtSaida(moment(despesa.dt_saida).utc().format('DD/MM/YYYY'));
        setDtChegada(moment(despesa.dt_chegada).utc().format('DD/MM/YYYY'));
        setObjetivo(despesa.objetivo);
        setAutorizacao(despesa.autorizacao);
        setBanco(despesa.banco);
        setAgencia(despesa.agencia);
        setConta(despesa.conta);
        setCc(despesa.cc);
        setGd(despesa.gd);
        setQtdCombustivel((despesa.qtd_combustivel ? despesa.qtd_combustivel.toString() : ''));
        setVlrCombustivel(handleMaskValor((despesa.vlr_combustivel ? despesa.vlr_combustivel : 0).toFixed(2)));
        setQtdAlimentacao((despesa.qtd_alimentacao ? despesa.qtd_alimentacao.toString() : ''));
        setVlrAlimentacao(handleMaskValor((despesa.vlr_alimentacao ? despesa.vlr_alimentacao : 0).toFixed(2)));
        setQtdHospedagem((despesa.qtd_hospedagem ? despesa.qtd_hospedagem.toString() : ''));
        setVlrHospedagem(handleMaskValor((despesa.vlr_hospedagem ? despesa.vlr_hospedagem : 0).toFixed(2)));
        setQtdPedagio((despesa.qtd_pedagio ? despesa.qtd_pedagio.toString() : ''));
        setVlrPedagio(handleMaskValor((despesa.vlr_pedagio ? despesa.vlr_pedagio : 0).toFixed(2)));
        setQtdOutros((despesa.qtd_outros ? despesa.qtd_outros.toString() : ''));
        setVlrOutros(handleMaskValor((despesa.vlr_outros ? despesa.vlr_outros : 0).toFixed(2)));
        setVlrTaxi(handleMaskValor((despesa.vlr_taxi ? despesa.vlr_taxi : 0).toFixed(2)));
        setQtdTaxi((despesa.qtd_taxi ? despesa.qtd_taxi.toString() : ''));
        setVlorAdiantamento(handleMaskValor((despesa.vlr_adiantamento ? despesa.vlr_adiantamento : 0).toFixed(2)));
        setId(despesa.id);
        setDtPgto((despesa.dt_pgto ? moment(despesa.dt_pgto).utc().format('DD/MM/YYYY') : ''));
        setTitularidade(despesa.titularidade);
        setCpf(despesa.cpf);

        setModalNovaDespOpen(true);
    }

    function handleConfirmPgto(id) {
        setModalPgtoOpen(true);
        setIdDespPagar(id);
    }

    function handlePagar() {

        if (!dtPagar || dtPagar === '') {
            Swal.fire('A DATA NÃO PODE FICAR EM BRANCO!');
            return;
        }
        var body = {};
        body.dtpgto = dtPagar;

        if (pagando) {
            return;
        }
        Swal.fire({
            title: "TEM CERTEZA QUE DESEJA PAGAR A DESPESA?",
            showDenyButton: true,
            showConfirmButton: true,
            denyButtonText: "CANCELAR",
            confirmButtonText: "CONFIRMAR",
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                setPagando(true);
                api.put(`/despviagem/pay/id/${idDespPagar}`, body).then(function (response) {
                    if (response.data) {
                        setDespesas([]);
                        var objdesp = Object.assign([], despesas);
                        var index = objdesp.findIndex(desp => desp.id === parseInt(idDespPagar));
                        objdesp[index] = response.data;
                        setDespesas(objdesp);
                        Swal.fire(`DESPESA PAGA EM ${moment(new Date()).utc().format('DD/MM/YYYY')}`);
                        // setLogEmpresa(response.data);
                    }
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                }).then(function () {
                    // always executed
                    setPagando(false);
                    setIdDespPagar('');
                    setModalPgtoOpen(false);
                    setDtPagar('');
                });

            } else if (result.isDenied) {

            }
        })

    }

    function renderValuePgto(despesa) {
        if (canPay) {
            if (!despesa.dt_pgto || despesa.dt_pgto === '') {
                return (
                    // <td><input type="checkbox" onChange={() => handlePagar(despesa.id)} /></td>
                    <td><BsCurrencyDollar color='green' size="25" onClick={() => handleConfirmPgto(despesa.id)} /></td>
                )
            } else {
                return (
                    <td></td>
                )
            }
        }

    }

    function renderDespesas() {
        if (pagando) {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        } else {
            return (
                despesas.map((despesa) => {
                    return (
                        <tr className={styles.linha} key={despesa.id}>
                            {renderValuePgto(despesa)}
                            <td onClick={() => handleClickDesp(despesa)}>{(despesa.dt_pgto ? "PAGO EM: " + moment(despesa.dt_pgto).utc().format('DD/MM/YYYY') : "AGUARD. PGTO.")}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.id}-{moment(despesa.createdAt).utc().format('YYYY')}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.nome}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.matricula}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.funcao}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.setor}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.origem}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{despesa.destino}</td>
                            <td onClick={() => handleClickDesp(despesa)}>{moment(despesa.createdAt).utc().format('DD/MM/YYYY')}</td>
                            <td onClick={() => handleClickDesp(despesa)}>
                                {
                                    ((despesa.qtd_alimentacao * despesa.vlr_alimentacao) +
                                        (despesa.qtd_combustivel * despesa.vlr_combustivel) +
                                        (despesa.qtd_hospedagem * despesa.vlr_hospedagem) +
                                        (despesa.vlr_outros * despesa.qtd_outros) +
                                        (despesa.vlr_taxi * despesa.qtd_taxi) +
                                        (despesa.qtd_pedagio * despesa.vlr_pedagio)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                }
                            </td>
                            <td >{(!despesa.dt_pgto ? <BsFileExcelFill color="red" onClick={() => handleExcluirDesp(despesa.id)} /> : "")}</td>
                        </tr>
                    )
                })
            )
        }
    }

    function handleMaskValor(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            // ",9", ",99", "9,99", "99,99", "999,99", "9.999,99", "99.999,99", "999.999,99", "9.999.999,99", "99.999.999,99", "999.999.999,99"
            ",9", ",99", ",999", ",9999", ",99999", "9,99999", "99,99999", "999,99999", "9.999,99999", "99.999,99999", "999.999,99999", "9.999.999,99999", "99.999.999,99999", "999.999.999,99999"
        ]);
        return (maskedValue);
    }

    function fechaModalNovaDesp() {
        setNome('');
        setMatricula('');
        setFuncao('');
        setSetor('');
        setOrigem('');
        setDestino('');
        setDtSaida('');
        setDtChegada('');
        setObjetivo('');
        setAutorizacao('');
        setBanco('');
        setAgencia('');
        setConta('');
        setCc('');
        setGd('');
        setQtdCombustivel('');
        setVlrCombustivel('');
        setQtdAlimentacao('');
        setVlrAlimentacao('');
        setQtdHospedagem('');
        setVlrHospedagem('');
        setQtdOutros('');
        setVlrOutros('');
        setVlrTaxi('');
        setQtdTaxi('');
        setVlorAdiantamento('');
        setId('');
        setDtPgto('');
        setTitularidade('');
        setCpf('');
        setQtdPedagio('');
        setVlrPedagio('');

        setModalNovaDespOpen(false);
    }

    function handleClickGravar() {

        if (salvando) {
            return;
        }
        if (nome === '') {
            Swal.fire('NOME É OBRIGATÓRIO!');
            return;
        }

        if (origem === '') {
            Swal.fire('ORIGEM É OBRIGATÓRIO!');
            return;
        }

        if (destino === '') {
            Swal.fire('DESTINO É OBRIGATÓRIO!');
            return;
        }

        if (dtSaida === '') {
            Swal.fire('DATA DE SAIDA É OBRIGATÓRIO!');
            return;
        }

        if (dtChegada === '') {
            Swal.fire('DATA DE CHEGADA É OBRIGATÓRIO!');
            return;
        }

        if (objetivo === '') {
            Swal.fire('OBJETIVO É OBRIGATÓRIO!');
            return;
        }

        if (autorizacao === '') {
            Swal.fire('AUTORIZAÇÃO É OBRIGATÓRIO!');
            return;
        }

        if (cc === '') {
            Swal.fire('CENTRO DE CUSTO É OBRIGATÓRIO!');
            return;
        }

        if (gd === '') {
            Swal.fire('GRUPO DE DESPESA É OBRIGATÓRIO!');
            return;
        }

        if (parseFloat(valorReceber) > 0) {
            if ((!banco || banco === '') || (!agencia || agencia === '') || (!conta || conta === '') || (!titularidade || titularidade === '') || (!cpf || cpf === '')) {
                Swal.fire('QUANDO HOUVER VALORES A RECEBER, OS DADOS BANCÁRIOS SÃO OBRIGATÓRIOS')
                return;
            }
        }

        var obj = {
            nome,
            matricula: parseInt(matricula),
            funcao,
            setor,
            origem,
            destino,
            objetivo,
            dtSaida,
            dtChegada,
            autorizacao,
            banco,
            conta,
            agencia,
            cc,
            gd,
            qtdCombustivel: parseFloat(qtdCombustivel.replace(',', '.')),
            vlrCombustivel: parseFloat(vlrCombustivel.replaceAll('.', '').replace(',', '.')),
            qtdHospedagem: parseFloat(qtdHospedagem.replace(',', '.')),
            vlrHospedagem: parseFloat(vlrHospedagem.replaceAll('.', '').replace(',', '.')),
            qtdAlimentacao: parseFloat(qtdAlimentacao.replace(',', '.')),
            vlrAlimentacao: parseFloat(vlrAlimentacao.replaceAll('.', '').replace(',', '.')),
            qtdOutros: parseFloat(qtdOutros.replace(',', '.')),
            vlrOutros: parseFloat(vlrOutros.replaceAll('.', '').replace(',', '.')),
            vlrTaxi: parseFloat(vlrTaxi.replaceAll('.', '').replace(',', '.')),
            qtdTaxi: parseFloat(qtdTaxi.replace(',', '.')),
            vlrAdiantamento: parseFloat(vlrAdiantamento.replaceAll('.', '').replace(',', '.')),
            qtdPedagio: parseFloat(qtdPedagio.replaceAll('.', '').replace(',', '.')),
            vlrPedagio: parseFloat(vlrPedagio.replaceAll('.', '').replace(',', '.')),
            cpf: cpf,
            titularidade: titularidade,
        }



        if (id && id !== '') {
            obj.id = id;
            setSalvando(true);
            api.put(`/despviagem`, obj).then(function (response) {
                if (response.data) {
                    var objdesp = Object.assign([], despesas);
                    var index = objdesp.findIndex(desp => desp.id === parseInt(id));
                    objdesp[index] = response.data;
                    setDespesas(objdesp);
                    // fechaModalNovaDesp();
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
                setSalvando(false);
            });
        } else {
            setSalvando(true);
            api.post(`/despviagem`, obj).then(function (response) {
                if (response.data) {
                    var objdesp = Object.assign([], despesas);
                    objdesp.push(response.data);
                    setDespesas(objdesp);
                    setId(response.data.id)
                    // fechaModalNovaDesp();
                    // setLogEmpresa(response.data);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
                setSalvando(false);
            });
        }


    }

    function handleMaskData(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        return (maskedValue);
    }

    function renderDadosPgto() {
        if (parseFloat(valorReceber) > 0) {
            return (
                <>
                    <div className={styles.grupobancario}>
                        <div className={styles.divcampos}>
                            <label>BANCO*</label>
                            <input type="text" value={banco} onChange={(e) => setBanco(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>AGENCIA*</label>
                            <input type="text" value={agencia} onChange={(e) => setAgencia(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>CONTA*</label>
                            <input type="text" value={conta} onChange={(e) => setConta(e.target.value)} />
                        </div>
                    </div>

                    <div className={styles.titularidade}>
                        <div className={styles.divcampos}>
                            <label>TITULARIDADE*</label>
                            <input type="text" value={titularidade} onChange={(e) => setTitularidade(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>CPF*</label>
                            <input type="text" value={cpf} onChange={(e) => setCpf(e.target.value)} />
                        </div>
                    </div>
                </>
            )
        } else {
            return (
                <>
                    <div className={styles.grupobancario}>
                        <div className={styles.divcampos}>
                            <label>BANCO</label>
                            <input type="text" value={banco} onChange={(e) => setBanco(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>AGENCIA</label>
                            <input type="text" value={agencia} onChange={(e) => setAgencia(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>CONTA</label>
                            <input type="text" value={conta} onChange={(e) => setConta(e.target.value)} />
                        </div>
                    </div>

                    <div className={styles.titularidade}>
                        <div className={styles.divcampos}>
                            <label>TITULARIDADE</label>
                            <input type="text" value={titularidade} onChange={(e) => setTitularidade(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>CPF</label>
                            <input type="text" value={cpf} onChange={(e) => setCpf(e.target.value)} />
                        </div>
                    </div>
                </>
            )
        }
    }

    function renderModalNovaDesp() {
        return (
            <div
                className={(modalNovaDespOpen ? styles.modaldesp : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalNovaDesp()}
                ><b>x</b></span>
                <div>
                    <h3><b>NOVA DESPESA DE VIAGEM</b></h3>
                </div>
                <div>
                    <hr />
                    <div className={styles.agrupcolaborador}>
                        <div className={styles.divcampos}>
                            <label>NOME*</label>
                            <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>MATRICULA</label>
                            <input className={styles.camponumerico} type="text" value={matricula} onChange={(e) => setMatricula(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>FUNÇÃO</label>
                            <input type="text" value={funcao} onChange={(e) => setFuncao(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>SETOR</label>
                            <input type="text" value={setor} onChange={(e) => setSetor(e.target.value)} />
                        </div>
                    </div>
                    <hr />
                    <div className={styles.origemdest}>
                        <div className={styles.divcampos}>
                            <label>ORIGEM DE PARTIDA*</label>
                            <input type="text" value={origem} onChange={(e) => setOrigem(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>DESTINO*</label>
                            <input type="text" value={destino} onChange={(e) => setDestino(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>DATA SAIDA*</label>
                            <input type="text" value={dtSaida} onChange={(e) => setDtSaida(handleMaskData(e.target.value))} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>DATA CHEGADA*</label>
                            <input type="text" value={dtChegada} onChange={(e) => setDtChegada(handleMaskData(e.target.value))} />
                        </div>
                    </div>
                    <hr />
                    <div className={styles.divcampos}>
                        <label>OBJETIVO*</label>
                        <input type="text" value={objetivo} onChange={(e) => setObjetivo(e.target.value)} />
                    </div>
                    <hr />
                    <div className={styles.divcampos}>
                        <label>AUTORIZADO POR*</label>
                        <input type="text" value={autorizacao} onChange={(e) => setAutorizacao(e.target.value)} />
                    </div>
                    <hr />
                    <hr />
                    <div className={styles.grupocc}>
                        <div className={styles.divcampos}>
                            <label>C. CUSTO*</label>
                            <input type="text" value={cc} onChange={(e) => setCc(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>G. DESPESA*</label>
                            <input type="text" value={gd} onChange={(e) => setGd(e.target.value)} />
                        </div>
                    </div>
                    <hr />
                    <div className={styles.grupovalores}>
                        <div className={styles.divcampos}>
                            <label>QTD. COMBUSTÍVEL</label>
                            <input type="text" value={qtdCombustivel} onChange={(e) => setQtdCombustivel(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>VLR. COMBUSTÍVEL</label>
                            <input type="text" value={vlrCombustivel} onChange={(e) => setVlrCombustivel(handleMaskValor(e.target.value))} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>QTD. ALIMENTAÇÃO</label>
                            <input type="text" value={qtdAlimentacao} onChange={(e) => setQtdAlimentacao(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>VLR. ALIMENTAÇÃO</label>
                            <input type="text" value={vlrAlimentacao} onChange={(e) => setVlrAlimentacao(handleMaskValor(e.target.value))} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>QTD. HOSPEDAGEM</label>
                            <input type="text" value={qtdHospedagem} onChange={(e) => setQtdHospedagem(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>VLR. HOSPEDAGEM</label>
                            <input type="text" value={vlrHospedagem} onChange={(e) => setVlrHospedagem(handleMaskValor(e.target.value))} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>QTD. OUTROS</label>
                            <input type="text" value={qtdOutros} onChange={(e) => setQtdOutros(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>VLR. OUTROS</label>
                            <input type="text" value={vlrOutros} onChange={(e) => setVlrOutros(handleMaskValor(e.target.value))} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>QTD. TÁXI</label>
                            <input type="text" value={qtdTaxi} onChange={(e) => setQtdTaxi(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>VLR. TÁXI</label>
                            <input type="text" value={vlrTaxi} onChange={(e) => setVlrTaxi(handleMaskValor(e.target.value))} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>QTD. PEDAGIO</label>
                            <input type="text" value={qtdPedagio} onChange={(e) => setQtdPedagio(e.target.value)} />
                        </div>
                        <div className={styles.divcampos}>
                            <label>VLR. PEDAGIO</label>
                            <input type="text" value={vlrPedagio} onChange={(e) => setVlrPedagio(handleMaskValor(e.target.value))} />
                        </div>
                    </div>
                    <hr />
                    <div className={styles.divcampos}>
                        <label>VALOR DO ADIANTAMENTO(QUANDO HOUVER)</label>
                        <input type="text" value={vlrAdiantamento} onChange={(e) => setVlorAdiantamento(handleMaskValor(e.target.value))} />
                    </div>
                    <hr />
                    <div className={styles.divcampos}>
                        <label>VALOR TOTAL</label>
                        <input type="text" value={(valorTotal ? valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "R$ 0,00")} readOnly className={styles.readOnly} />
                    </div>
                    <hr />
                    <div className={styles.divcampos}>
                        <label>VALOR A DEVOLVER</label>
                        <input type="text" value={(valorDevolver ? valorDevolver.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "R$ 0,00")} readOnly className={styles.readOnly} />
                    </div>
                    <hr />
                    <div className={styles.divcampos}>
                        <label>VALOR A RECEBER</label>
                        <input type="text" value={(valorReceber ? valorReceber.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : "R$ 0,00")} readOnly className={styles.readOnly} />
                    </div>

                    {renderDadosPgto()}

                    <hr />
                    <div className={styles.contentbtn}>
                        {renderGravar()}
                        {renderImprimir()}
                    </div>
                </div>
            </div>
        )
    }

    function handlePrint(id) {

        setDownloading(true);

        api.post(`/despviagem/report`, { id: id }, {
            responseType: 'blob',
        }).then(function (response) {
            if (response.data) {

                if (response.data.erro) {
                    alert(response.data.erro)
                } else {

                    fileDownload(response.data, 'ANOMALIA.pdf');

                }

            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
            setDownloading(false);
        });


    }

    function renderImprimir() {
        if (id && id !== '') {
            if (!downloading) {
                return (
                    <div className={styles.btns}>
                        <input type="button" value="IMPRIMIR" className='btn btn-success' onClick={() => handlePrint(id)} />
                    </div>
                )
            } else {
                return (
                    <div className={styles.divloading}>
                        <div className={styles.loading}></div>
                    </div>
                )
            }
        }
    }

    function renderGravar() {
        if (!dtPgto || dtPgto === '') {
            if (!salvando) {
                return (
                    <div className={styles.btns}>
                        <input type="button" value="SALVAR" className='btn btn-primary' onClick={() => handleClickGravar()} />
                    </div>
                )
            } else {
                return (
                    <div className={styles.divloading}>
                        <div className={styles.loading}></div>
                    </div>
                )
            }
        } else {
            return (<></>)
        }
    }

    function handleShowModal() {
        setModalNovaDespOpen(true);
    }

    function renderTitlePgto() {
        if (canPay) {
            return (
                <th>PAGAR</th>
            )
        } else {
            return (<></>)
        }
    }

    function handleSelectValue(value, obj) {
        const objselected = Object.assign([], obj);
        objselected.selectItem = value;
        return objselected;
    }

    function renderMinhasDesps() {
        return (
            <select
                className="col-md-12 combobox  edit form-control column-filtro"
                id="tipo"
                value={status.selectItem}
                onChange={(e) => setStatus(handleSelectValue(e.target.value, status))}
            // ref={tipoRef}
            // onKeyDown={(e) => handledown(e, etapaRef)}
            >
                {status.items.map((item, index) => (
                    <option key={index} value={item.id}>{item.text}</option>
                ))}
            </select>
        )

    }

    function fechaModalPgto() {
        setModalPgtoOpen(false);
    }

    function renderModalPgto() {
        return (
            <div
                className={(modalPgtoOpen ? styles.modaldesp : "modal-fechado")}
            >
                <span
                    className="fechar-modal-previsoes"
                    onClick={() => fechaModalPgto()}
                ><b>x</b></span>
                <div>
                    <h3><b>DATA DO PAGAMENTO</b></h3>
                </div>
                <div>
                    <input type="text" value={dtPagar} onChange={(e) => setDtPagar(handleMaskData(e.target.value))} />
                </div>
                <input type="button" onClick={() => handlePagar()} value="CONFIRMAR" />
            </div>
        )
    }

    return (
        <>
            {renderModalNovaDesp()}
            {renderModalPgto()}
            <div className="container-lg">
                <Header title="DESPESAS DE VIAGEM" />
                <input type="button" className={styles.btnverde} value="NOVA DESPESA" onClick={() => handleShowModal()} />
                <hr />
                {renderMinhasDesps()}
                <hr />
                <div className={styles.tbdesp}>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                {renderTitlePgto()}
                                <th>STATUS</th>
                                <th>TITULO</th>
                                <th>NOME</th>
                                <th>MATRICULA</th>
                                <th>FUNÇÃO</th>
                                <th>SETOR</th>
                                <th>ORIGEM</th>
                                <th>DESTINO</th>
                                <th>DATA LCTO.</th>
                                <th>VALOR</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderDespesas()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}